import React, {useContext} from "react";
import MomentUtils from '@date-io/moment';
import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {WizardContext} from "../context";
import {useStyles} from "../styles";
import {FormControl, FormControlLabel, Radio, RadioGroup, TextField, Typography} from "@material-ui/core";
import {CAMPAIGN_TYPE} from "../constants";
import {DashboardContext} from '../../Dashboard/context';
import moment from "moment";

const WizardStep2 = () => {
  const {formData, fieldChange} = useContext(WizardContext);
  const {advertiser} = useContext(DashboardContext);
  const classes = useStyles();

  const MaxResponsesAvailable = 100;

  console.log(advertiser);

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'stretch' }}>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
        <FormControl className={classes.formControl}>
          <Typography id="campaign-type" gutterBottom>
            Choose campaign type
          </Typography>
          <RadioGroup name='campaign-type' value={formData.campaignType} onChange={fieldChange('campaignType')}>
            {Object.keys(CAMPAIGN_TYPE).filter((item) => {
              if (advertiser.advertiser_email.indexOf('@focusloop') > -1) {
                return true;
              }

              return item !== 'free';
            }).map(campaignType => (
              <FormControlLabel
                key={campaignType}
                control={<Radio color='primary' />}
                value={campaignType}
                label={<Typography className={classes.radioGroupLabel}>{CAMPAIGN_TYPE[campaignType]}</Typography>}
                labelPlacement='end'
              />
            ))}
          </RadioGroup>
        </FormControl>
        <FormControl className={classes.formControl}>
          <Typography id="total-responses-field" gutterBottom>
            Total number of responses desired
          </Typography>
          <TextField
            id='total-responses-field'
            type='number'
            fullWidth
            value={formData.totalResponses}
            onChange={fieldChange('totalResponses')}
          />
          <Typography className={classes.radioGroupLabel}>
            Response points purchased: {MaxResponsesAvailable}<br/>
            Need to add points: {formData.totalResponses > MaxResponsesAvailable ?  formData.totalResponses - MaxResponsesAvailable : 0}
          </Typography>
        </FormControl>
        <FormControl className={classes.formControl}>
          <Typography gutterBottom>
            Choose campaign launch date
          </Typography>
          <RadioGroup name='response-type' value={formData.launchDateChoose} onChange={fieldChange('launchDateChoose')}>
            <FormControlLabel
              control={<Radio color='primary' />}
              value='now'
              label={<Typography className={classes.radioGroupLabel}>Right away</Typography>}
              labelPlacement='end'
            />
            <FormControlLabel
              control={<Radio color='primary' />}
              value='custom'
              label={<Typography className={classes.radioGroupLabel}>At a later date</Typography>}
              labelPlacement='end'
            />
          </RadioGroup>
          {formData.launchDateChoose === 'custom' && (
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <DateTimePicker
                value={formData.launchDate}
                minDate={moment(new Date())}
                onChange={value => fieldChange('launchDate')({target: { value }})}
              />
            </MuiPickersUtilsProvider>
          )}
        </FormControl>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
        <FormControl className={classes.formControl}>
          <Typography gutterBottom>
            Choose campaign duration
          </Typography>
          <RadioGroup name='response-type' value={formData.campaignEndWhen} onChange={fieldChange('campaignEndWhen')}>
            <FormControlLabel
              control={<Radio color='primary' />}
              value='allResponses'
              label={<Typography className={classes.radioGroupLabel}>End campaign when all responses are received</Typography>}
              labelPlacement='end'
            />
            <FormControlLabel
              control={<Radio color='primary' />}
              value='custom'
              label={<Typography className={classes.radioGroupLabel}>Set an expiration date</Typography>}
              labelPlacement='end'
            />
          </RadioGroup>
          {formData.campaignEndWhen === 'custom' && (
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <DateTimePicker
                value={formData.endDate}
                minDate={moment(new Date())}
                maxDate={formData.launchDate.add(14, 'days')}
                onChange={value => fieldChange('endDate')({target: { value }})}
              />
            </MuiPickersUtilsProvider>
          )}
        </FormControl>
        {formData.campaignType === 'coupon' && (
          <FormControl className={classes.formControl}>
            <Typography gutterBottom>
              Coupon Expiry Date
            </Typography>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <DateTimePicker
                value={formData.endDate}
                minDate={moment(new Date())}
                onChange={value => fieldChange('endDate')({target: { value }})}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
        )}
      </div>
    </div>
  )
};

export default WizardStep2;
